/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FeatureUnit } from './FeatureUnit';
import {
    FeatureUnitFromJSON,
    FeatureUnitFromJSONTyped,
    FeatureUnitToJSON,
} from './FeatureUnit';
import type { FeatureValue } from './FeatureValue';
import {
    FeatureValueFromJSON,
    FeatureValueFromJSONTyped,
    FeatureValueToJSON,
} from './FeatureValue';

/**
 * Representation of a Feature
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * Code of the feature
     * @type {string}
     * @memberof Feature
     */
    code?: string;
    /**
     * Name of the feature
     * @type {string}
     * @memberof Feature
     */
    name?: string;
    /**
     * Description of the feature
     * @type {string}
     * @memberof Feature
     */
    description?: string;
    /**
     * Type of the feature
     * @type {string}
     * @memberof Feature
     */
    type?: string;
    /**
     * Range number of the feature
     * @type {boolean}
     * @memberof Feature
     */
    range?: boolean;
    /**
     * Flag defining it feature is comparable
     * @type {boolean}
     * @memberof Feature
     */
    comparable?: boolean;
    /**
     * 
     * @type {FeatureUnit}
     * @memberof Feature
     */
    featureUnit?: FeatureUnit;
    /**
     * List of feature values
     * @type {Array<FeatureValue>}
     * @memberof Feature
     */
    featureValues?: Array<FeatureValue>;
}

/**
 * Check if a given object implements the Feature interface.
 */
export function instanceOfFeature(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FeatureFromJSON(json: any): Feature {
    return FeatureFromJSONTyped(json, false);
}

export function FeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): Feature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'range': !exists(json, 'range') ? undefined : json['range'],
        'comparable': !exists(json, 'comparable') ? undefined : json['comparable'],
        'featureUnit': !exists(json, 'featureUnit') ? undefined : FeatureUnitFromJSON(json['featureUnit']),
        'featureValues': !exists(json, 'featureValues') ? undefined : ((json['featureValues'] as Array<any>).map(FeatureValueFromJSON)),
    };
}

export function FeatureToJSON(value?: Feature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'description': value.description,
        'type': value.type,
        'range': value.range,
        'comparable': value.comparable,
        'featureUnit': FeatureUnitToJSON(value.featureUnit),
        'featureValues': value.featureValues === undefined ? undefined : ((value.featureValues as Array<any>).map(FeatureValueToJSON)),
    };
}

